/* SoSlanty custom JS — managed via API */

/* 1. Fix: Horizon's announcement bar suspends rotation on mouseenter and never resumes. */
(function () {
  function arm(el) {
    el.addEventListener('mouseleave', function () {
      try { if (typeof el.resume === 'function') el.resume(); } catch (e) {}
    });
  }
  function init() { document.querySelectorAll('announcement-bar-component').forEach(arm); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* 2. Floating category headline: split into words (unbreakable) then characters, so each
      letter carries its own colour and its slice of the drop-in + wobble animation.
      Long sayings get stepped down in size via data-len. */
(function () {
  var COLOURS = 5;
  function build(el) {
    if (el.dataset.sfhDone === '1') return;
    var text = (el.textContent || '').trim();
    if (!text) return;
    el.dataset.sfhDone = '1';
    el.dataset.len = text.length > 70 ? 'xlong' : (text.length > 45 ? 'long' : 'normal');
    el.setAttribute('aria-label', text);        // screen readers get the phrase, not the letters
    el.textContent = '';
    var i = 0;
    var words = text.split(/\s+/);
    words.forEach(function (word, w) {
      var wordEl = document.createElement('span');
      wordEl.className = 'sfh-word';
      wordEl.setAttribute('aria-hidden', 'true');
      word.split('').forEach(function (ch) {
        var span = document.createElement('span');
        span.className = 'sfh-char sfh-c' + (i % COLOURS);
        span.style.setProperty('--i', i);
        span.textContent = ch;
        wordEl.appendChild(span);
        i++;
      });
      el.appendChild(wordEl);
      if (w < words.length - 1) {
        var sp = document.createElement('span');
        sp.className = 'sfh-space';
        sp.setAttribute('aria-hidden', 'true');
        sp.innerHTML = '&nbsp;';
        el.appendChild(sp);
      }
    });
  }
  function init() { document.querySelectorAll('.soslanty-floating-headline').forEach(build); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();

/* 3. Collection-context product links: while browsing a collection, product cards link to
      /collections/<handle>/products/<p> so the product page knows which category the shopper
      came from and the breadcrumb points back there. Re-applies after Horizon re-renders the
      grid (filtering / pagination) via a MutationObserver. */
(function () {
  var m = location.pathname.match(/^\/collections\/([a-z0-9-]+)\/?$/);
  if (!m || m[1] === 'all' || m[1] === 'frontpage') return;
  var prefix = '/collections/' + m[1];
  function rewrite(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('a[href^="/products/"]').forEach(function (a) {
      a.setAttribute('href', prefix + a.getAttribute('href'));
    });
  }
  function init() {
    var main = document.getElementById('MainContent');
    if (!main) return;
    rewrite(main);
    new MutationObserver(function (muts) {
      muts.forEach(function (mu) {
        mu.addedNodes.forEach(function (n) {
          if (n.nodeType === 1) rewrite(n);
        });
      });
    }).observe(main, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
